export default "__VITE_ASSET__BbkV4n6z__"